/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../ui-elements/touchable.directive';
import * as import5 from './link.component';
const styles_LinkComponent:any[] = ([] as any[]);
export const RenderType_LinkComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LinkComponent,
  data: {}
}
);
function View_LinkComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'link-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.label,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
function View_LinkComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[
      [
        'class',
        'link-action'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.activate($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'underlined',
      'disabled',
      'negative',
      'plain'
    ]
    ),
    import0.ɵdid(4210688,(null as any),0,import4.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'link-action';
    const currVal_1:any = ck(v,2,0,co.underlined,co.disabled,co.negative,co.plain);
    ck(v,1,0,currVal_0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import0.ɵunv(v,4,0,import0.ɵnov(v,5).transform(co.link,co.translationParams));
    ck(v,4,0,currVal_2);
  });
}
function View_LinkComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'link-postscript'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.postscript,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
export function View_LinkComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LinkComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LinkComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LinkComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.LinkComponent = v.component;
    const currVal_0:any = co.label;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.link;
    ck(v,4,0,currVal_1);
    const currVal_2:any = co.postscript;
    ck(v,7,0,currVal_2);
  },(null as any));
}
function View_LinkComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),(null as any),(null as any),View_LinkComponent_0,RenderType_LinkComponent)),
    import0.ɵdid(49152,(null as any),0,import5.LinkComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const LinkComponentNgFactory:import0.ComponentFactory<import5.LinkComponent> = import0.ɵccf('woa-link',import5.LinkComponent,View_LinkComponent_Host_0,{
  label: 'label',
  link: 'link',
  postscript: 'postscript',
  translationParams: 'translationParams',
  underlined: 'underlined',
  disabled: 'disabled',
  negative: 'negative',
  plain: 'plain'
}
,{onActivate: 'onActivate'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/buttons/link/link.component.ngfactory.ts